export default __webpack_public_path__ + "static/media/r4_catalyst_favonius_codex.8b88e9dc.png";